import { Platform } from 'react-native';

import { LANGUAGE_KEYS } from 'config/languageKeys.ts';

import {
    CONCURENCY_ERROR_CODE,
    GENERIC_SSM_SETUP_ERROR_CODE,
    INVALID_HEARTBEAT_PERIOD_ERROR_CODE,
} from 'services/ssm/constants';

import { BitmovinPlayerError } from 'components/Player/types.ts';

import { PlayerError } from '../types.ts';

const { ERR_GENERIC_TITLE } = LANGUAGE_KEYS;

export const CDN_PLAYER_ERRORS_MAP: Record<string, PlayerError> = {
    '400': {
        message: 'CDN_ERROR_TITLE',
        description: 'CDN_ERROR_BAD_REQUEST_BODY',
        code: '400 Bad Requests',
    },
    '403': {
        message: 'CDN_ERROR_TITLE',
        description: 'CDN_ERROR_FORBIDDEN_BODY',
        code: '403 Forbidden',
    },
    '404': {
        message: 'CDN_ERROR_TITLE',
        description: 'CDN_ERROR_NOT_FOUND_BODY',
        code: '404 Not found',
    },
    '405': {
        message: 'CDN_ERROR_TITLE',
        description: 'CDN_ERROR_METHOD_NOT_ALLOWED_BODY',
        code: '405 Method Not Allowed',
    },
    '504': {
        message: 'CDN_ERROR_TITLE',
        description: 'CDN_ERROR_GETAWAY_TIMEOUT_BODY',
        code: '504 Gateway Timeout',
    },
    '505': {
        message: 'CDN_ERROR_TITLE',
        description: 'CDN_ERROR_HTTP_VERSION_NOT_SUPPORTED_BODY',
        code: '505 HTTP Version Not Supported',
    },
};

export function isConcurrencyError(error: BitmovinPlayerError) {
    return error.code === 6004;
}

const errorsTable: {
    codes: number[] | { start: number; end: number };
    description: string;
}[] = [
    {
        codes: Platform.select({
            web: { start: 1200, end: 1299 },
            ios: [
                2101, 2202, 2205, 2210, 2220, 2221, 2222, 2223, 2224, 2230,
                2231, 2232, 2233, 2234,
            ],
            android: { start: 2000, end: 2299 },
            default: [],
        }),
        description: 'PLAYER_SOURCE_TYPE_ERROR',
    },
    {
        codes: Platform.select({
            web: { start: 1400, end: 1499 },
            ios: [1200],
            android: { start: 1200, end: 1299 },
            default: [],
        }),
        description: 'PLAYER_NETWORK_TYPE_ERROR',
    },
    {
        codes: Platform.select({
            web: { start: 2000, end: 2099 },
            ios: [2301, 2302, 2303, 2309, 2306, 2307],
            android: { start: 2300, end: 2399 },
            default: [],
        }),
        description: 'PLAYER_DRM_TYPE_ERROR',
    },
    {
        codes: [
            GENERIC_SSM_SETUP_ERROR_CODE,
            CONCURENCY_ERROR_CODE,
            INVALID_HEARTBEAT_PERIOD_ERROR_CODE,
        ],
        description: 'PLAYER_SSM_TYPE_ERROR',
    },
    // TODO There is no such error segments in Bitmovin player docs.
    // { start: 2001, end: 2100, description: 'PLAYER_MEDIA_TYPE_ERROR' },
    // { start: 7001, end: 7024, description: 'PLAYER_TYPE_ERROR' },
];

export function getErrorDescription(errorCode?: number | null | string) {
    if (typeof errorCode === 'number') {
        const error = errorsTable.find(({ codes }) => {
            if (Array.isArray(codes)) {
                return codes.some((_code) => _code === errorCode);
            }

            if (codes.start != null && codes.end != null) {
                return codes.start <= errorCode && codes.end >= errorCode;
            }

            return false;
        });

        return error?.description ?? ERR_GENERIC_TITLE;
    }

    return ERR_GENERIC_TITLE;
}
